'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    t: _propTypes2.default.func.isRequired
};
//# sourceMappingURL=contextTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-translations/dist/main/contextTypes.js
// module id = 277
// module chunks = 0